import { setLocation } from 'utils/wrappers';
import CreateCarrierAccountModal from 'app/views/modals/create_carrier_account_modal';

import Base from 'app/views/base';
import tmpl from 'templates/carrier_type_list_item';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click.carrier_type': 'carrierAccountListItemClicked',
  },

  initialize(options) {
    this.carrierAccounts = options.carrierAccounts;
    this.createCarrierAccountModal = new CreateCarrierAccountModal({
      model: this.model,
      collection: this.carrierAccounts,
    });
  },

  context() {
    return {
      readable: this.model.get('readable'),
      type: this.model.get('type'),
    };
  },

  carrierAccountListItemClicked(event) {
    event.preventDefault();
    if (this.model.get('fields').custom_workflow) {
      setLocation(`/carrier-custom-workflow/${this.model.get('type')}`);
    } else {
      this.createCarrierAccountModal.show();
    }
  },
});



// WEBPACK FOOTER //
// ./app/views/carrier_type_list_item_view.js